/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateStockupItem201ResponseAllOfData } from './CreateStockupItem201ResponseAllOfData';
import {
    CreateStockupItem201ResponseAllOfDataFromJSON,
    CreateStockupItem201ResponseAllOfDataFromJSONTyped,
    CreateStockupItem201ResponseAllOfDataToJSON,
} from './CreateStockupItem201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateStockupItem201Response
 */
export interface CreateStockupItem201Response {
    /**
     * 
     * @type {CreateStockupItem201ResponseAllOfData}
     * @memberof CreateStockupItem201Response
     */
    data: CreateStockupItem201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateStockupItem201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateStockupItem201Response interface.
 */
export function instanceOfCreateStockupItem201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateStockupItem201ResponseFromJSON(json: any): CreateStockupItem201Response {
    return CreateStockupItem201ResponseFromJSONTyped(json, false);
}

export function CreateStockupItem201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStockupItem201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateStockupItem201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateStockupItem201ResponseToJSON(value?: CreateStockupItem201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateStockupItem201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

